// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"55fc2127","787":"7da95b79"}[chunkId] + ".chunk.js";
};